import { render, staticRenderFns } from "./ClientComp.vue?vue&type=template&id=c2655b18&scoped=true&"
import script from "./ClientComp.vue?vue&type=script&lang=js&"
export * from "./ClientComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2655b18",
  null
  
)

export default component.exports